import { IApplicationState } from '../../types/redux';

export const selectSupplyDemandData = (state: IApplicationState) => state.marketTrand.supplyDemandData;
